import { render, staticRenderFns } from "./AgeBarChart.vue?vue&type=template&id=672e2e4f"
import script from "./AgeBarChart.vue?vue&type=script&lang=js"
export * from "./AgeBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports